import {React, Component} from 'react'


import Header from '../../components/Header/Header'
import notFoundGif from '../../assets/404.gif'
import './NotFound.css';


class NotFound extends Component {
  constructor(props){
    super(props)
    this.state = {
    }
  }


  

  render(){
    return (
      <div className="NotFound">
          <Header/>
          <div style={{fontSize:"65px", margin:"20px 0px 40px 0px", fontWeight:"900", letterSpacing:"3px"}}>404</div>
          <img style={{borderRadius:"5px", width:"35%"}} src={notFoundGif} alt="Feeling Blue"/>
      </div>
                              
    
    );
  
  }
}

export default NotFound;
